/**
 * Telegram Mini App — Past Exam Practice
 *
 * Wraps PastESSLCEQuiz for ESLCE exam practice inside Telegram.
 * URL: /tg/exams?subject=X&topic=Y
 *
 * Features: Topic/year filters, question bank, AI help, session persistence.
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import TelegramShell from '../components/TelegramShell';
import PastESSLCEQuiz from '../components/MicroLearning/PastESSLCEQuiz';
import './TelegramExams.css';

const TelegramExamsInner: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { student, isLoading } = useAuth();

  const subject = searchParams.get('subject') || '';
  const topic = searchParams.get('topic') || undefined;

  if (isLoading) {
    return (
      <div className="tg-exams-loading">
        <p>Loading past exams...</p>
      </div>
    );
  }

  if (!subject) {
    return (
      <div className="tg-exams-error">
        <p>No subject specified. Please go back and try again.</p>
        <button onClick={() => window.Telegram?.WebApp?.close()}>Close</button>
      </div>
    );
  }

  return (
    <div className="tg-exams">
      <PastESSLCEQuiz
        subject={subject}
        topic={topic}
        studentId={student?.student_id}
      />
    </div>
  );
};

const TelegramExams: React.FC = () => {
  return (
    <TelegramShell>
      <TelegramExamsInner />
    </TelegramShell>
  );
};

export default TelegramExams;
